import type { JwtPayload } from "@slfinrtl/ppn-roles"
import { jwtDecode } from "jwt-decode"

export const getJwtPayload = (): JwtPayload | undefined => {
	const token = window.localStorage.getItem("id_token")
	return token ? jwtDecode<JwtPayload>(token) : undefined
}
